<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="!hasAnnouncements()"
  [dismissableMask]="!hasAnnouncements()"
  [closeOnEscape]="!hasAnnouncements()"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '70vw', maxWidth: '800px', maxHeight: '60vh'}"
  [header]="'What\'s New on Portal'"
  (onHide)="onClose()"
  styleClass="announcements-dialog">
  
  <ng-container *ngIf="announcements.length === 0; else announcementsList">
    <div class="empty-state flex flex-column align-items-center justify-content-center py-5">
      <i class="pi pi-info-circle text-5xl text-gray-300 mb-4"></i>
      <p class="text-lg text-gray-700 mb-2 font-medium">No new announcements</p>
      <small class="text-gray-500">You’re all caught up! Check back here later for updates.</small>
    </div>
  </ng-container>

  <ng-template #announcementsList>
    <div class="announcements-container">
      <div 
        *ngFor="let item of sanitizedAnnouncements; let i = index" 
        class="announcement-card mb-3">
        <div class="announcement-header mb-3">
          <h4 class="announcement-title">{{ item.announcement.title }}</h4>
          <span class="announcement-date">{{ item.announcement.publishedDate | date: 'MM/dd/yyyy' : 'UTC' }}</span>
        </div>
        <div 
          class="announcement-content" 
          [innerHTML]="item.sanitizedContent">
        </div>
        <ng-container *ngIf="sanitizedAnnouncements.length > 1 && i < sanitizedAnnouncements.length - 1 && false">
          <hr class="announcement-divider my-4" />
        </ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button 
      *ngIf="hasAnnouncements()"
      label="Later" 
      styleClass="border-round-md" 
      [text]="true" 
      [severity]="'contrast'" 
      (onClick)="onClose()">
    </p-button>
    <p-button 
      *ngIf="hasAnnouncements()"
      label="Got it" 
      styleClass="p-button-danger acknowledge-button ml-2 border-round-md" 
      [raised]="true"
      [loading]="acknowledging"
      [disabled]="acknowledging"
      (onClick)="onAcknowledgeAll()">
    </p-button>
  </ng-template>
</p-dialog>

